export const enum TextPropertiesEnum {
    CheckFontWeight = "checkFontWeight", 
    CheckFontStyle = "checkFontStyle", 
    CheckLeft = "checkLeft", 
    CheckCenter = "checkCenter", 
    CheckRight = "checkRight", 
    CheckJustify = "checkJustify",
    Text = "text",
    Linethrough = "linethrough",
    Underline = "underline",
    Fill = "fill",
    FontSize = "fontSize"
}